module.exports = __webpack_public_path__ + "3m_theme_assets/web_apps/apps/mmmSOSI-2022explorer/images/0450849aed5ebec08a38cd49512fe21f.png";